import { enumFromValue } from '@pushly/models'

export function safeEnumFromValue<T>(enu: { [key: string]: T; UNSPECIFIED: T }, value: string | number): T {
    try {
        return enumFromValue(enu, value)
    } catch (_) {}

    return enu.UNSPECIFIED
}
